import { useState } from "react";
import { Moon, Sun } from "lucide-react";

const apply = (dark) => document.documentElement.classList.toggle("dark", dark);
apply(localStorage.getItem("btp_theme") === "dark");

export function ThemeToggle() {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));
  const toggle = () => {
    const next = !dark;
    setDark(next);
    apply(next);
    localStorage.setItem("btp_theme", next ? "dark" : "light");
  };
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle-btn"
      aria-label={dark ? "Mode clair" : "Mode sombre"}
      className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 grid place-items-center transition-colors"
    >
      {dark ? <Sun className="w-5 h-5 text-amber-400" /> : <Moon className="w-5 h-5" />}
    </button>
  );
}
